import axios from 'axios';
import { ENTERPRISE_SERVER } from '../components/Config.js';

export function verifyCode(dataToSubmit){
    return axios.post(`${ENTERPRISE_SERVER}/verify-code`, dataToSubmit).then(response => response.data);
}